import {BIN_LABEL_STYLES, BIN_ON_DURATION_MS, COLOR_MAP} from '../util/constant';
import {
    ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT,
    LED_CONTROLLER_ASSET_TYPE,
    ON_STATE
} from "../../../../util/Constants";
import {getAPIGatewayPostRequest} from "../../../../util/Util";
import {getAPIGatewayDataFromParent} from "../../../../handler/ParentDataHandler";

const COLOR_ARRAY = Object.keys(COLOR_MAP).map((colorName) => COLOR_MAP[colorName]);

class BinController {
    // TODO: add bin label style (US: aisle.bin; EU: aisle-bin)
    constructor(siteId, color, aisle, binLabelStyle) {
        console.log(`BinController siteId=${siteId}`);
        this.siteId = siteId;
        this.color = color;
        this.aisle = aisle;
        this.binLabelStyle = binLabelStyle;
    }

    /**
     * Start LED blinking for a bin
     * @param {String} bin label of a bin(A-1.1A for NA, A1-1A for EU)
     * @returns {String} rgb color encoding
     */
    async blink(bin) {
        const request = {
            nodeId : this.siteId,
            assetType : LED_CONTROLLER_ASSET_TYPE,
            commandParams : {
                locationType : "BIN",
                state : ON_STATE,
                color : BinController._getColor(this.color),
                binLocation : this._generateBinLabel(bin)
            }
        }
        const args = getAPIGatewayPostRequest(request, ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT);
        await getAPIGatewayDataFromParent(args);
        return BinController._getColor(this.color).slice(4);
    }

    _generateBinLabel(bin) {
        if (bin.includes('-') || bin.includes('.')) {
            return bin;
        }
        switch (this.binLabelStyle) {
            case BIN_LABEL_STYLES.EU:
                return `${this.aisle}-${bin}`;
            case BIN_LABEL_STYLES.NA:
                return `${this.aisle}.${bin}`;
            case BIN_LABEL_STYLES.IN_SC:
                return bin;
            default:
                return `${this.aisle}.${bin}`;
        }
    }

    /**
     * Generate MQTT command to blink a bin
     * @param {String} bin label of a bin(A-1.1A for NA, A1-1A for EU)
     * @returns {Object} MQTT command
     */
    _generateMqttCommand(bin) {
        const binLabel = this._generateBinLabel(bin);
        return {
            commands: [{
                state: 'ON',
                color: BinController._getColor(this.color),
                duty: 15,
                period: 400,
                count: Math.ceil(BIN_ON_DURATION_MS / 400),
                delay: 0,
                tagLocationIds: [binLabel],
                tagLabels: [
                    binLabel
                ],
                sensor: 'led'
            }]
        };
    }

    static _getColor(color) {
        if (!color || !COLOR_MAP[color]) {
            return COLOR_ARRAY[Math.round(Math.random() * 6)];
        }
        return COLOR_MAP[color];
    }

}
export default BinController;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/business/bin-cotroller.js